
export default {
	bookingList: [],
	bookings: {},

	lotteryEntries: {},
	lotteryEntryIds: [],
}